module.exports = new __parcel__URL__("delivery-light.3a73ce5e.svg").toString();